import clsx from "classnames"
import { GridSlotSize } from "common/types/graphql"
import { PropsWithChildren, forwardRef, ForwardedRef } from "react"

export interface ImmutableGridSlotProps {
  /** True if the grid slot should be rendered as a placeholder, false otherwise. */
  asPlaceholder?: boolean

  /** indicates whether the grid slot is being dropped (mouse over) */
  isOver?: boolean

  /** The size of the grid slot. */
  size?: GridSlotSize
}

/** A read-only grid slot. */
export const ImmutableGridSlot = forwardRef(function ImmutableGridSlot(
  {
    size = GridSlotSize.Base,
    asPlaceholder = false,
    isOver = false,
    children,
  }: PropsWithChildren<ImmutableGridSlotProps>,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <div
      className={clsx("group relative flex overflow-hidden", {
        "col-span-2 sm:col-span-1": size === GridSlotSize.Base,
        "col-span-2": size === GridSlotSize.BaseWide,
        "col-span-2 row-span-2": size === GridSlotSize.Lg,
        "col-span-2 row-span-4": size === GridSlotSize.Xl,
        "col-span-full": size === GridSlotSize.Xxl,
        "m-2.5 min-h-28 bg-blue-100 outline-dashed outline-offset-8": asPlaceholder,
        "outline-dashed outline-2 outline-offset-4 outline-gray-700": isOver,
        "outline-1 outline-blue-500": asPlaceholder && !isOver,
        "outline-2 outline-gray-700": asPlaceholder && isOver,
        "border-t pt-4": !asPlaceholder,
      })}
      ref={ref}
      data-testid="ImmutableGridSlot"
    >
      {children}
    </div>
  )
})
